import { render, staticRenderFns } from "./2JQv0Rq3y5.vue?vue&type=template&id=58fab260&scoped=true"
import script from "./2JQv0Rq3y5.vue?vue&type=script&lang=js"
export * from "./2JQv0Rq3y5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fab260",
  null
  
)

export default component.exports